import { render, staticRenderFns } from "./ReminderMessage.vue?vue&type=template&id=b9dc6494&scoped=true&"
import script from "./ReminderMessage.vue?vue&type=script&lang=js&"
export * from "./ReminderMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReminderMessage.vue?vue&type=style&index=0&id=b9dc6494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dc6494",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
